const PATH_COLLECTION = '/collections'
const PATH_INDEX = '/'
const PATH_SEARCH = '/search'
// メインカテゴリのコレクションのハンドル
// STG環境については考慮していない
const HANDLE_MAIN_CATEGORY_COLLECTIONS = [
  'furniture',
  'electronics',
  'fabric',
  'curtain',
  'kitchen',
  'fragrance',
  'health_beauty',
  'storage',
  'fashion_goods',
  'interior_goods',
  'outdoor_goods',
]

const pathname = globalThis.location.pathname

export const isIndexPage = pathname === PATH_INDEX
export const isCollectionPage = pathname.startsWith(PATH_COLLECTION)
export const isSearchPage = pathname.startsWith(PATH_SEARCH)

export const isMainCategoryPage = HANDLE_MAIN_CATEGORY_COLLECTIONS.some(
  (handle) => pathname.startsWith(`${PATH_COLLECTION}/${handle}`)
)
